import { render, staticRenderFns } from "./AttachUpload.vue?vue&type=template&id=7a122da4&scoped=true"
import script from "./AttachUpload.vue?vue&type=script&lang=js"
export * from "./AttachUpload.vue?vue&type=script&lang=js"
import style0 from "./AttachUpload.vue?vue&type=style&index=0&id=7a122da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a122da4",
  null
  
)

export default component.exports